import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

/**
 * Auth-Konfiguration aus dem Event-Dokument (Customer_{slug}.events).
 * Enthält beide Netzwerk-Scopes, damit der Aufruf nicht auf den Pixel-Test warten muss.
 */
export interface EventAuthConfig {
  authMode: {
    int: string | null;
    ext: string | null;
  };
  whitelistEnabled: boolean;
  /**
   * Betreibt der Kunde ein internes Verteilnetz? Aus core.companies.
   * Ist es false, kann der Pixel-Test nur 'ext' ergeben und wird übersprungen.
   */
  hasDistributionNetwork: boolean;
  /**
   * Wie der Zugang zugestellt wird.
   *
   * 'link' → Magic-Link in der Mail, mehrfach einlösbar (Mail-Clients rufen Links vorab ab)
   * 'code' → sechsstelliger Code zum Eintippen, genau einmal gültig
   */
  deliveryMode: 'link' | 'code';
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  // Node-Backend. Die Auth-Routen (config/request/confirm/session) sind bislang nur im
  // Test-Service deployed, deshalb hier kein production-Schalter wie in den übrigen Services.
  private api = environment.apiUrl + 'v1/test-event-backend'; //API HERE
  // Klassisches PHP-Backend. Login, initAuth und der Mediathek-Token laufen weiter darüber.
  private phpApi = environment.apiUrl + 'api';

  login(credentials): Observable<any> {
    return this.http.post(`${this.phpApi}/authentication/login.php`, {
      email: credentials.email,
      password: credentials.password
    }, httpOptions);
  }


/**
 * Lädt die Auth-Konfiguration aus dem Event-Dokument.
 *
 * 404 bedeutet, dass das Event noch nicht nach Customer_{slug}.events migriert ist —
 * dann gilt weiterhin config_setup.json. Der Aufrufer muss diesen Fall behandeln.
 */
getAuthConfig(): Observable<EventAuthConfig> {
  return this.http.get<EventAuthConfig>(`${this.api}/authentication/config`);
}

 requestEmailLogin(email: string, lang: string, title: string, subtitle: string, mode: 'int' | 'ext'): Observable<any> {
  console.log('Requesting email login for:', email, lang, title, subtitle, mode);
  return this.http.post<any>(
    `${this.api}/authentication/request`,
    { email, lang, title, subtitle, mode }
  );
}

/**
 * Meldet einen Zugriff ohne Login (Scope hat authEnabled = false).
 *
 * Gezählt werden Browser, nicht Personen: der Schlüssel ist eine localStorage-UUID.
 * Der Server verwirft die Meldung, wenn das Event gar nicht mit Magic-Link arbeitet.
 * Fehler werden bewusst verschluckt — das Zählen darf den Seitenaufruf nie blockieren.
 */
trackSession(clientId: string, mode: 'int' | 'ext'): Observable<any> {
  return this.http.post<any>(
    `${this.api}/authentication/session`,
    { clientId, mode }
  );
}

/**
 * Löst einen sechsstelligen Code ein.
 *
 * Die E-Mail-Adresse muss mit: der Code allein ist zu kurz, um ihn ungebunden
 * nachzuschlagen — sechs Ziffern wären vollständig durchprobierbar.
 */
confirmEmailCode(email: string, code: string) {
  return this.http.post<any>(
    `${this.api}/authentication/confirm-code`,
    { email, code }
  );
}

confirmEmailToken(token: string) {
  return this.http.post<any>(
    `${this.api}/authentication/confirm`,
    { token }
  );
}
  initAuth(mode: string): Observable<any>{
    return this.http.get(`${this.phpApi}/setup/setup.php?x=get_setup&mode=${mode}`, httpOptions);
  }
  /**
   * Login über den Mediathek-Token.
   *
   * Liegt weiter im PHP-Backend: setup.php entschlüsselt den Token und gibt das JWT
   * zurück. Über `this.api` (Node) gibt es diese Route nicht — der Aufruf lief dort
   * ins 404 und die Mediathek-Nutzer landeten auf dem Passwort-Formular.
   */
  mediaLibAuth(mtoken: string,token:string): Observable<any>{
    let storage = new Array();
    storage['jwt'] = '';
    if(localStorage.getItem("medialibrary-auth-user-"+token)){
       storage =JSON.parse(localStorage.getItem("medialibrary-auth-user-"+token));
    }
    return this.http.post(`${this.phpApi}/setup/setup.php?x=medialib`, {
      token: mtoken,
      jwt: storage['jwt']
    }, httpOptions);
  }
}
